// @ts-nocheck
document.addEventListener('click', function (event) {
  var target = event.target;
  if (!target || typeof target.closest !== 'function') return;
  var btn = target.closest('.cart-upsell__btn[data-variant-id]');
  if (!btn) return;

  btn.disabled = true;
  btn.textContent = '…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: Number(btn.dataset.variantId), quantity: 1 }),
  })
    .then(function (r) { return r.json(); })
    .then(function () {
      document.dispatchEvent(
        new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } })
      );
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = 'Añadir';
    });
});
